(function () {
  'use strict';

  /* Respect prefers-reduced-motion — bail out entirely */
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* ── Stagger targets (grouped per immediate parent) ── */
  var STAGGER_SELECTORS = [
    '.universe-card',
    '.product-card',
    '.ambassadrices-teaser-perk',
    '.reassurance-item'
  ];

  /* ── Mark .shopify-section wrappers for section-level reveal ── */
  document.querySelectorAll('.shopify-section').forEach(function (el) {
    el.classList.add('cocoonette-reveal');
  });

  /* ── Mark stagger children, reset delay counter per parent ── */
  STAGGER_SELECTORS.forEach(function (sel) {
    var countByParent = new Map();
    document.querySelectorAll(sel).forEach(function (el) {
      var parent = el.parentElement;
      var idx = countByParent.get(parent) || 0;
      el.classList.add('cocoonette-reveal-child');
      el.style.transitionDelay = (idx * 100) + 'ms';
      countByParent.set(parent, idx + 1);
    });
  });

  /* ── Single IntersectionObserver for all targets ── */
  if (!window.IntersectionObserver) {
    /* Fallback: make everything visible immediately */
    document.querySelectorAll('.cocoonette-reveal, .cocoonette-reveal-child').forEach(function (el) {
      el.classList.add('cocoonette-reveal--visible');
    });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('cocoonette-reveal--visible');
      /* Remove delay after animation so it doesn't linger if element re-enters DOM */
      entry.target.addEventListener('transitionend', function cleanup() {
        entry.target.style.transitionDelay = '';
        entry.target.removeEventListener('transitionend', cleanup);
      }, { once: true });
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -32px 0px' });

  document.querySelectorAll('.cocoonette-reveal, .cocoonette-reveal-child').forEach(function (el) {
    observer.observe(el);
  });
})();
